import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { SortByOption } from "../../../app/index";
import { useAppConfig } from "../../../hooks";

type SortControlsProps = {
  currentSort: SortByOption;
  onSortChange: (sort: SortByOption) => void;
};

const sortLabels: Record<SortByOption, string> = {
  prezzo_crescente: "Prezzo ↑",
  prezzo_decrescente: "Prezzo ↓",
  brand_crescente: "A - Z ↑",
  brand_decrescente: "Z - A ↓",
};

export const SortControls = ({ currentSort, onSortChange }: SortControlsProps) => {
  const { ctaColor, ctaTextColor } = useAppConfig();

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        bgColor={ctaColor}
        color={ctaTextColor}
        _hover={{ bg: ctaColor }}
        _active={{
          bg: ctaColor,
          transform: "scale(0.98)",
          borderColor: ctaColor,
        }}
        fontSize={["sm", "md"]}
        px={2}
        iconSpacing={2}
        minW="fit-content"
      >
        {sortLabels[currentSort]}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => onSortChange("prezzo_crescente")}>
          {sortLabels["prezzo_crescente"]}
        </MenuItem>
        <MenuItem onClick={() => onSortChange("prezzo_decrescente")}>
          {sortLabels["prezzo_decrescente"]}
        </MenuItem>
        <MenuItem onClick={() => onSortChange("brand_crescente")}>
          {sortLabels["brand_crescente"]}
        </MenuItem>
        <MenuItem onClick={() => onSortChange("brand_decrescente")}>
          {sortLabels["brand_decrescente"]}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

